import { defineMessages } from 'react-intl';

export default defineMessages({
  opensInNewWindow: {
    id: 'bitkit.navigation.opensInNewWindow',
    description:
      'Text used for screen readers and notifying that link will be opened in a new window or tab',
    defaultMessage: ', opens in a new window or tab',
  },
});
